export default "__VITE_ASSET__B9n3Q88u__"